import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import Headline3 from './Typography/Heading/Headline3';
import breakpoints from './Theme/breakpoints';

export const WfbTitle = styled(Headline3)`
  && {
    margin: 16px;
  }
  text-align: center;
`;

export const JobsLandingAds = styled.div`
  && {
    width: auto;
    grid-column-end: span 4;
    align-self: center;

    @media (min-width: ${breakpoints.lg}px) {
      grid-column-end: span 3;
    }
  }
`;

const WfbAdsWrapper = styled.div`
  margin: 0 0 16px;
  padding: 16px 0;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 32px;
  @media (min-width: ${breakpoints.xssm}px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 48px;
  }
  @media (min-width: ${breakpoints.md}px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: ${breakpoints.lg}px) {
    grid-template-columns: repeat(4, 1fr);
  }
  && > a {
    text-align: center;
    & > div {
      display: inline-block;
    }
  }
`;

const wfbAdsPropertyTypes = {
  wfbAds: PropTypes.arrayOf(
    PropTypes.node.isRequired,
  ).isRequired,
};

type WfbAdsProperties = InferProps<typeof wfbAdsPropertyTypes>;

const WfbAds = ({
  wfbAds,
}: WfbAdsProperties) => (
  <WfbAdsWrapper>
    { wfbAds }
  </WfbAdsWrapper>
);

WfbAds.propTypes = wfbAdsPropertyTypes;

export default WfbAds;
